<template>
    <button @click="sendLink" v-bind="$attrs">
        <svg class="icon" aria-label="페이스북 공유" :width="size" :height="size" :viewBox="`0 0 48 48`" preserveAspectRatio="xMidYMid meet">
            <g fill="none" fill-rule="evenodd">
                <path fill="#3B5998" d="M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24z"></path>
                <path fill="#FFF" d="M25.77 35V24h3.384v-3.385h-3.385v-2.538c-.012-.756.08-1.285 1.693-1.692h1.692V13h-3.385c-3.25 0-4.52 1.84-4.23 5.077v2.538H19V24h2.538v11h4.231z"></path>
            </g>
        </svg>
        <span>페이스북</span>
    </button>
</template>

<script>
export default {
    props: {
        size: { type: String, default: "60" },
    },
    methods: {
        sendLink() {
            FB.ui(
                {
                    display: "popup",
                    method: "share",
                    href: "https://ssezip.com" + this.$route.path,
                },
                function(response) {}
            );
        },
    },
};
</script>
